// const api = {
//   dev: window.env.REACT_APP_DEV_BASE_URL,
//   stage: window.env.REACT_APP_STAGE_BASE_URL,
//   production: window.env.REACT_APP_PROD_BASE_URL,
//   local: window.env.REACT_APP_LOCAL_BASE_URL
// };

const envVars = window.env;

const api = {
  dev: envVars.REACT_APP_DEV_BASE_URL,
  qa: envVars.REACT_APP_STAGE_BASE_URL,
  production: envVars.REACT_APP_PROD_BASE_URL,
  local: envVars.REACT_APP_LOCAL_BASE_URL
};

const env = envVars.REACT_APP_ENV || "production";

const apiURL = api[env];

export default apiURL;
